import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Button, RadioButton } from '../../canvasComponents/index';
import { FormattedMessage, injectIntl } from 'react-intl';
import introIllustration from '../../img/services/services-intro.svg';
import UberLogo from '../../img/services/uber-default.svg';
import EnterpriseLogo from '../../img/services/enterprise-default.svg';
import messages from './messages';
import './ServicesLanding.scss';
import '../../css/domain/Services/Services.scss';
import { getRouteUrl } from '../../FormioComponents/utils';

function ServicesLanding({ serviceTypeCallback, claimData, serviceData, uber, enterprise, saveAndContinueLater, updateCurrentPage, uberAmount }) {
  const [serviceType, setServiceType] = useState(serviceData?.rentalType);
  const [error, setError] = useState(false);

  const onClickServiceButtonHandler = () => {
    if (serviceType) {
      serviceTypeCallback(serviceType);
    } else {
      setError(true);
    }
  };
  useEffect(() => { setError(false); }, [serviceType]);
  useEffect(() => {
    window.history.pushState({}, window.location.pathname, `#/${getRouteUrl(document.querySelector('.services-heading')?.textContent, 'Vehicle') || ''}`);
  }, []);

  useEffect(() => {
    updateCurrentPage(messages.landingHeading, 1);
  }, []);

  return (
    <Container fluid className="dashboard-content">
      <Grid>
        <Typography h1 center className="services-heading">
          <FormattedMessage {...messages.landingHeading} />
        </Typography>
        <div className="services-divider">
          <Grid.Row justifyContentBetween className="reverse-col">
            <Grid.Column colMd8>
              <div className="services-copy mb-18">
                <p>
                  <FormattedMessage {...messages.landingIntroCopy} />
                </p>
                {enterprise && (
                  <>
                    <strong className="subtitle">
                      <FormattedMessage {...messages.landingIntroEnterprise} />
                    </strong>
                    <p>
                      <FormattedMessage {...messages.landingIntroEnterpriseDes} />
                    </p>
                  </>
                )}
                {uber && (
                  <>
                    <strong className="subtitle"><FormattedMessage {...messages.landingIntroUber} /></strong>
                    <p><FormattedMessage {...messages.landingIntroUberDes} values={{ uberAmount }} /></p>
                  </>
                )}
                <p>
                  <strong><FormattedMessage {...messages.landingIntroHeadsupBold} /></strong>
                  <FormattedMessage {...messages.landingIntroHeadsup} />
                </p>

                <strong><FormattedMessage {...messages.radioTitle} /></strong>
              </div>
            </Grid.Column>
            <Grid.Column colMd3>
              <div className="right-h">
                <img src={introIllustration} alt="Car illustration" />
              </div>
            </Grid.Column>
          </Grid.Row>

          <div className="mb-20">
            {enterprise && (
              <RadioButton
                secondary
                id="id_radiobutton-enterprise"
                value="enterprise"
                name="choose-service"
                onChange={(value) => setServiceType(value)}
                checked={serviceType === 'enterprise'}
              >
                <FormattedMessage {...messages.radioEnterprise} />
              </RadioButton>
            )}

            {uber && (
              <RadioButton
                secondary
                id="id_radiobutton-uber"
                value="uber"
                name="choose-service"
                onChange={(value) => setServiceType(value)}
                checked={serviceType === 'uber'}
              >
                <FormattedMessage {...messages.radioUber} />
              </RadioButton>
            )}

            <RadioButton
              secondary
              id="id_radiobutton-ownRental"
              value="own_rental"
              name="choose-service"
              onChange={(value) => setServiceType(value)}
              checked={serviceType === 'own_rental'}
            >
              <FormattedMessage {...messages.ownRental} />
            </RadioButton>

            <RadioButton
              secondary
              id="id_radiobutton-claimExpert"
              value="claim_expert"
              name="choose-service"
              onChange={(value) => setServiceType(value)}
              checked={serviceType === 'claim_expert'}
            >
              <FormattedMessage {...messages.claimExpert} />
            </RadioButton>

            { error && <div className="error-container"><div className="error-text"><FormattedMessage {...messages.error} /></div></div>}

            <div className="centerBlock">
              {enterprise && <img src={EnterpriseLogo} alt="Enterprise Logo" className="centerBlock mr-16" style={{ height: '23px' }} /> }
              {uber && <img src={UberLogo} alt="Uber Logo" className="centerBlock" style={{ height: '23px' }} />}
            </div>
          </div>
        </div>
        <div className="center-v services-btns">
          <Button
            primary
            className="mb-20 services-continue-button"
            onClick={() => onClickServiceButtonHandler()}
          >
            <FormattedMessage {...messages.continueCta} />
          </Button>
          <Button
            className="btn save-continue-later"
            onClick={() => saveAndContinueLater('services', 'servicesLanding', claimData, true)}
          >
            <FormattedMessage {...messages.saveContinueCta} />
          </Button>
        </div>
      </Grid>
    </Container>
  );
}

export default injectIntl(ServicesLanding);
